<div id="content-wrapper" class="d-flex flex-column ml-0" *ngIf="_departments?.length">
  <div id="content">
    <div class="row top mb-3">
      <div class="col-md-12">
        <div class="row justify-content-center">
          <h1>{{label}}を選択</h1>
        </div>
        <div class="row justify-content-center">
          <p>(※複数選択いただけます)</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <div class="row">
          <div class="col-md-12">
            <div class="row mb-3" *ngFor="let category of _departments">
              <label class="col-form-label mb-3 py-0 text-caption">{{category.category}}</label>
              <div class="col-md-12 text-left ">
                <div class="row">
                  <div class="col-md-4" *ngFor="let item of category.departments;">

                    <div class="form-group row no-gutters justify-content-left terms-checkbox">
                      <div class="custom-control custom-checkbox custom-control-lg">
                        <input type="checkbox" class="custom-control-input" [id]="item" [(ngModel)]="selected[item]" />
                        <label class="custom-control-label" [for]="item">
                          {{item}}
                        </label>
                      </div>
                    </div>
                    <!-- <input type="checkbox" [id]="item" [(ngModel)]="selected[item]"> -->
                    <!-- <label [for]="item">{{item}}</label> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row justify-content-between pr-3 pl-3">
      <!-- <div class="col-md-12"> -->
      <button id="cancel_button" (click)="cancel();">キャンセル</button>
      <app-doctors-next-button style="width: 120px;" (click)="apply();" label="確定する"></app-doctors-next-button>
      <!-- </div> -->
    </div>
  </div>
</div>